import { useClientLocationUserProfile } from 'service-api/src/hooks/use_client_location_user_profiles'
import { useClientGetReportCardByAllPetIds } from './use_client_get_report_card_by_all_pet_ids'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

export const useLocationUserPetReportCards = ({ lupId, enabled }: { lupId: string; enabled: boolean }): boolean => {
  const { accountName: locationName = '' } = useParams()
  const { data: locationUserProfile } = useClientLocationUserProfile(
    locationName,
    lupId,
    ['locationPetProfiles'],
    enabled
  )
  const petIds = useMemo(() => {
    return locationUserProfile?.locationPetProfiles
      ? locationUserProfile.locationPetProfiles?.map((pet) => pet.id || '')
      : []
  }, [locationUserProfile?.locationPetProfiles])

  const { data: reportCardData } = useClientGetReportCardByAllPetIds(locationName, petIds)
  return !!(reportCardData && reportCardData?.length > 0)
}
